import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonService } from '../../services';
import { CommonHttpService } from '../../services/common-http.service';
import { ConfirmationService } from 'primeng/api';
import { SpinnerService } from '../../services/spinner.service';
import { Subscription } from 'rxjs';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'bi-report-security',
  standalone: false,
  templateUrl: './report-security.component.html',
  styleUrl: './report-security.component.scss',
  providers: [ConfirmationService]
})
export class ReportSecurityComponent implements OnInit, OnDestroy {
  visible2: boolean = false;
  roleList: any[] = [];
  teamList: any[] = [];
  viewAllAccess: boolean = false;
  RoleDisabledOpt: boolean = false;
  editAllAccess: boolean = true;
  editRoleDisabled: boolean = false;
  isUpdated: boolean = false;
  editRoleList: any[] = [];
  editTeamList: any[] = [];
  selectedRoles: any[] = [];
  selectedTeams: any[] = [];
  reportItem: any;
  reportSecurity: any;
  checked: boolean = false;
  private _subscription: Subscription = new Subscription();
  reportSecurityForm!: FormGroup;
  isLoadingScheduledReports: boolean = false;
  enableHierarchySecurityValue: any;
  enableHierarchySecurity: any;
  enableHierarchyAccess: any;
  viewAccessCondition: boolean = false;

  ngOnInit(): void {
    this.visible2 = false;
    this.initForm();
    this.setupReportSecuritySubscription();
  }
  constructor(
    private _commonService: CommonService,
    private _commonHttpService: CommonHttpService,
    private confirmationService: ConfirmationService,
    private spinnerService: SpinnerService,
    private _fb: FormBuilder
  ) {
    this.initForm();
  }
  getUserList() {
    this._commonHttpService.getUserList(this.reportItem).subscribe((data: any) => {
      next: (state: any) => {
        if (!state || typeof state.show !== 'boolean') {
          this.visible2 = false;
          return;
        }
        this.visible2 = state.show;
      }
    });
  }

  ngOnDestroy(): void {
    if (this._subscription) {
      this._subscription.unsubscribe();
    }
  }
  setupReportSecuritySubscription(): void {
    this._subscription.add(
      this._commonService.reportLevelSecurityForm.subscribe((state: any) => {
        if (state && state.show) {
          this.visible2 = true;
          this.loadSecurityData();
        } else {
          this.visible2 = false;
        }
      })
    );
  }


  loadSecurityData(): void {
    this.reportItem = this._commonService.reportLevelSecurityData;
    // const reportId = this.reportItem.reportFrom == 2 || this.reportItem.id !== '' ? this.reportItem.id : this.reportItem.reportId;
    const reportId = this.reportItem.id;
    // Get roles and teams data
    // console.log('reportItem', this.reportItem);
    const data = { reportId: reportId , reportFrom : this.reportItem.childReport==1 ? 1 : 2};
    
    this.spinnerService.withSpinner(
      this._commonHttpService.getUserList(data),
      'Loading report security'
    ).subscribe((data: any) => {
      if (data) {
        this.reportSecurity = data.data.reportLevelSecurity;
        // Extract roles
        if (data.data.roleList && Array.isArray(data.data.roleList)) {
          this.roleList = data.data.roleList;
        }
        if (data.data.teamMembers && data.data.teamMembers.teamNames && Array.isArray(data.data.teamMembers.teamNames)) {
          this.teamList = data.data.teamMembers.teamNames;
        }
        this.getEditRoleAndTeamList(data.data.reportLevelSecurity);
       
        
        if (data.data.reportLevelSecurity) {
          // Patch the form controls with the valid role and team codes
          this.isUpdated = true;
          this.reportSecurityForm.patchValue({
            viewRoleIds: this.filterNullValues(data.data.reportLevelSecurity.viewRoleIds || []),
            viewTeamIds: this.filterNullValues(data.data.reportLevelSecurity.viewTeamIds || []),
            editRoleIds: this.filterNullValues(data.data.reportLevelSecurity.editRoleIds || []),
            editTeamIds: this.filterNullValues(data.data.reportLevelSecurity.editTeamIds || []),
            viewToAll: data.data.reportLevelSecurity.viewToAll,
            reportId: reportId,
            reportFrom: this.reportItem.reportFrom,
            enableHierarchySecurity: data.data.reportLevelSecurity.enableHierarchySecurity,
          });
          
          if(data.data.reportLevelSecurity.editToAll){
            this.reportSecurityForm.get('editToAll')?.setValue(data.data.reportLevelSecurity.editToAll);
            this.reportSecurityForm.get('editToAll')?.enable();
          } else {
            // this.reportSecurityForm.get('editToAll')?.setValue(data.data.reportLevelSecurity.editToAll);
            this.reportSecurityForm.get('editToAll')?.disable();
          }
        }

        // console.log('isUpdated', this.isUpdated);
      
        let viewRoleIds = this.reportSecurityForm.get('viewRoleIds')?.value || [];
        let viewTeamIds = this.reportSecurityForm.get('viewTeamIds')?.value || [];
        let editRoleIds = this.reportSecurityForm.get('editRoleIds')?.value || [];
        let editTeamIds = this.reportSecurityForm.get('editTeamIds')?.value || [];
        
        // View all access
        this.viewAccessCondition = (viewRoleIds.length === 0 || ((viewRoleIds[0] === 0 || viewRoleIds[0] === '0'))) && (viewTeamIds.length === 0 || ((viewTeamIds[0] === 0 || viewTeamIds[0] === '0'))) && data.data.reportLevelSecurity != null && data.data.reportLevelSecurity?.reportId !== '' && data.data.reportLevelSecurity.length > 0;
        console.log('viewAccessCondition', this.viewAccessCondition);
        if (this.viewAccessCondition) {
          this.reportSecurityForm.get('viewRoleIds')?.setValue([]);
          this.reportSecurityForm.get('viewTeamIds')?.setValue([]);
          this.viewAllAccess = true;
          this.RoleDisabledOpt = true;
          this.editAllAccess = false;
          this.checked = false;
        } else {
          this.viewAllAccess = false;
          this.RoleDisabledOpt = false;
          /*  this.editRoleList = this.roleList;
           this.editTeamList = this.teamList; */
          // this.editAllAccess = false;
        }

        // Edit all access
        if ((editRoleIds.length === 0 || ((editRoleIds[0] === 0 || editRoleIds[0] === '0'))) && (editTeamIds.length === 0 || ((editTeamIds[0] === 0 || editTeamIds[0] === '0' || editTeamIds[0] === null))) && data.data.reportLevelSecurity != null && data.data.reportLevelSecurity?.reportId !== '') {
          this.editAllAccess = true;
          this.editRoleDisabled = true;
          this.reportSecurityForm.get('editRoleIds')?.setValue([]);
          this.reportSecurityForm.get('editTeamIds')?.setValue([]);
        } else {
          // this.editAllAccess = false;
          this.checked = false;
          this.editRoleDisabled = false;
          /*  this.editRoleList = this.roleList;
           this.editTeamList = this.teamList; */
        }

        this.changeeditAllAccess({ ev: { checked: false } })
        if (this.reportSecurityForm.get('viewToAll')?.value) {
          this.changeViewAllAccess({ checked: this.reportSecurityForm.get('viewToAll')?.value });
        }

        if (this.reportSecurityForm.get('editToAll')?.value) {
          this.changeeditAllAccess({ checked: this.reportSecurityForm.get('editToAll')?.value });
        }
        // this.changeViewAllAccess({checked: this.reportSecurityForm.get('viewToAll')?.value});
        // this.changeeditAllAccess({checked: this.reportSecurityForm.get('editToAll')?.value});

        // Update form toggle values
        /* this.reportSecurityForm.patchValue({
          viewToAll: this.viewAllAccess,
          editToAll: this.editAllAccess
        }); */
      }
    },
    );
  }


  changeViewAllAccess(ev: any) {
    this.viewAllAccess = ev.checked;
    console.log('viewAllAccess', this.viewAllAccess);
    if (this.viewAllAccess) {
      this.editRoleList = this.roleList;
      this.editTeamList = this.teamList;
      this.RoleDisabledOpt = true;
      this.editAllAccess = false;
      this.editRoleDisabled = false;
      this.reportSecurityForm.get('viewRoleIds')?.setValue([]);
      this.reportSecurityForm.get('viewTeamIds')?.setValue([]);

      // Remove validators when viewAllAccess button is enabled
      this.reportSecurityForm.get('viewRoleIds')?.clearValidators();
      this.reportSecurityForm.get('viewRoleIds')?.updateValueAndValidity();

      // Enable the editToAll toggle switch
      this.reportSecurityForm.get('editToAll')?.enable();

    } else {
      if (this.isUpdated) {
        this.getEditRoleAndTeamList(this.reportSecurity);
      } else {
        this.editRoleList = []
        this.editTeamList = [];
      }
      this.RoleDisabledOpt = false;
      this.editAllAccess = false;
      this.editRoleDisabled = false;
      this.reportSecurityForm.get('editRoleIds')?.setValue([]);
      this.reportSecurityForm.get('editTeamIds')?.setValue([]);
      // if (this.isUpdated) {
      this.reportSecurityForm.get('viewRoleIds')?.setValue([]);
      this.reportSecurityForm.get('viewTeamIds')?.setValue([]);
      // }

      // Add back validators when viewAllAccess button is disabled
      this.reportSecurityForm.get('viewRoleIds')?.setValidators([Validators.required]);
      this.reportSecurityForm.get('viewRoleIds')?.updateValueAndValidity();

      // Disable the editToAll toggle switch
      this.reportSecurityForm.get('editToAll')?.setValue(false);
      this.reportSecurityForm.get('editToAll')?.disable();

    }
    // Update the form control value
    /*  this.reportSecurityForm.patchValue({
       viewToAll: this.viewAllAccess
     }); */
  }
  changeeditAllAccess(ev: any) {
    console.log('ev', ev);
    this.editAllAccess = ev.checked;
    if (this.editAllAccess) {
      this.editRoleDisabled = true;
      this.reportSecurityForm.get('editRoleIds')?.setValue([]);
      this.reportSecurityForm.get('editTeamIds')?.setValue([]);
    } else {
      // When edit all access is disabled, enable role and team selection
      this.editRoleDisabled = false;
      // this.editRoleList = this.roleList;
      // this.editTeamList = this.teamList;

    }
    // Update the form control value
    /* this.reportSecurityForm.patchValue({
      editToAll: this.editAllAccess
    }); */
  }

  /**Append selected roles to editRoleList */
  onRoleChange(event: any) {
    console.log('onRoleChange', event.itemValue);
    // Get current view role selections
    const viewRoleIds = this.filterNullValues(this.reportSecurityForm.get('viewRoleIds')?.value || []);
    const editRoleIds = this.filterNullValues(this.reportSecurityForm.get('editRoleIds')?.value || []);
    console.log('editRoleIds',  this.reportSecurityForm.get('editRoleIds'));

    if (typeof event.itemValue != 'object' && Array.isArray(editRoleIds)) {
      const index = editRoleIds.indexOf(event.itemValue);
      if (index > -1) { // Only splice array when item is found
        editRoleIds.splice(index, 1);
      }
      this.reportSecurityForm.get('editRoleIds')?.setValue(editRoleIds);
    }


    // Update editRoleList to reflect the selected view roles
    this.editRoleList = this.roleList.filter((role: any) =>
      viewRoleIds.includes(role.code)
    );

  }
  /** @description Append selected team options to editTeamList */
  onTeamChange(event: any) {

    // Get current view team selections
    const viewTeamIds = this.filterNullValues(this.reportSecurityForm.get('viewTeamIds')?.value || []);
    const editTeamIds = this.filterNullValues(this.reportSecurityForm.get('editTeamIds')?.value || []);
    // console.log('Current view team IDs:', viewTeamIds);

    // Update edit team form control to match view team selections
    /* this.reportSecurityForm.patchValue({
      editTeamIds: viewTeamIds
    }); */

    if (typeof event.itemValue != 'object' && Array.isArray(editTeamIds)) {
      const index = editTeamIds.indexOf(event.itemValue);
      if (index > -1) { // Only splice array when item is found
        editTeamIds.splice(index, 1);
      }
      this.reportSecurityForm.get('editTeamIds')?.setValue(editTeamIds);
    }

    // Update editTeamList to reflect the selected view teams
    this.editTeamList = this.teamList.filter((team: any) =>
      viewTeamIds.includes(team.code)
    );
  }

  initForm() {
    this.reportSecurityForm = this._fb.group({
      id: [null],
      reportId: [],
      reportFrom: [],
      viewRoleIds: [[], Validators.required],
      viewTeamIds: [[]],
      editRoleIds: [[]],
      editTeamIds: [[]],
      viewToAll: [this.viewAllAccess],
      // editToAll: [this.editAllAccess],
      editToAll: [{ value: false, disabled: true }],
      enableHierarchySecurity: [this.enableHierarchyAccess]
    });
  }
  closeDrawer() {
    this.visible2 = false;
    this._commonService.hideReportLevelSecurity();
  }
  saveReportSecurity(): void {
    this.reportItem = this._commonService.reportLevelSecurityData;
    if (this.reportSecurityForm.valid) {
      const formData = this.reportSecurityForm.value;
      formData.reportId = this.reportItem.reportFrom == 2 || this.reportItem.id !== '' ? this.reportItem.id : this.reportItem.reportId;
      formData.reportFrom = this.reportItem.reportFrom;
      this.spinnerService.withSpinner(
        this._commonHttpService.saveReportSecurity(formData),
        'Saving report security'
      ).subscribe({
        next: (response: any) => {
          this._commonService.hideReportLevelSecurity();
          // Update the report security flag in the current data
          if (this.reportItem) {
            this.reportItem.isReportLevelSecurity = 1;
          }
          // Trigger reload of saved report data after saving security
          this._commonService.triggerGetSavedReportData();
        },
        error: (error) => {
          console.error('Error saving report security:', error);
        }
      });
    } else {
      this.markFormGroupTouched();
      //console.error('Form is invalid:', this.reportSecurityForm.errors);
    }
  }

  onCancel(): void {
    this.visible2 = false;
    this.reportSecurityForm.reset();
    this._commonService.hideReportLevelSecurity();
  }

  getEditRoleAndTeamList(reportLevelSecurity: any) {
    if (!reportLevelSecurity) {
      this.editRoleList = [];
      this.editTeamList = [];
      return;
    }

    const viewRoleIds = this.filterNullValues(reportLevelSecurity.viewRoleIds || []);
    const viewTeamIds = this.filterNullValues(reportLevelSecurity.viewTeamIds || []);
    console.log('viewRoleIds', viewRoleIds);
    console.log('viewTeamIds', viewTeamIds);

    this.editRoleList = this.roleList.filter((role: any) => viewRoleIds.includes(role.code));
    this.editTeamList = this.teamList.filter((team: any) => viewTeamIds.includes(team.code));

    console.log('editRoleList', this.editRoleList);
    console.log('editTeamList', this.editTeamList);


  }

  changeHierarchyAccess(event: any) {
    this.reportSecurityForm.patchValue({
      enableHierarchySecurity: this.enableHierarchyAccess == 1 ? true : false
    });
    if (event.checked) {
      this.enableHierarchySecurityValue = this.enableHierarchySecurity ? 1 : 0;
      this.enableHierarchyAccess = true;
    } else {
      this.enableHierarchySecurityValue = this.enableHierarchySecurity ? 0 : 1;
      this.enableHierarchyAccess = false;
    }
  }
  markFormGroupTouched(): void {
    Object.keys(this.reportSecurityForm.controls).forEach(key => {
      const control = this.reportSecurityForm.get(key);
      control?.markAsTouched();
    });
  }

  /**
   * Helper method to filter out null and undefined values from arrays
   * @param arr - The array to filter
   * @returns Filtered array without null/undefined values
   */
  private filterNullValues(arr: any[]): any[] {
    return Array.isArray(arr) ? arr.filter(item => item !== null && item !== undefined && item !== 0) : [];
  }
}
